import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// import { getData, getSelectedLocation } from "@/utils";

// async function checkSelectedLocation(to, from, next) {
//   let location = getSelectedLocation();
//   if (!location) {
//     const response = await getData(`/customers/locations/`);
//     if (response) {
//       let item = response[0];
//       console.log("Default location", item.id);
//       window.sessionStorage.setItem("selected_location", item.id);
//     }
//   }
//   next();
// }



export default new Router({
  mode:'history',
  // base: process.env.BASE_URL,  
  routes: [
    {
      path: "/",
      redirect: "/login",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { title: 'Recommendations | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/MarketingAnalytics.vue")
        },
        {
          path: "/rfm-dashboard",
          name: "rfm-dashboard",
          meta: { title: 'RFM Dashboard | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/RfmDashboard.vue")
        },
        {
          path: "/basket-analytics",
          name: "basket-analytics",
          meta: { title: 'Basket Analytics | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/BasketAnalytics.vue")
        },
        {
          path: "/analytics/campaign-level",
          name: "campaign-level",
          meta: { title: 'Campaign Level Summary | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/StoreLevel.vue")
        },
        
        {
          path: "/locations",
          name: "locations",
          meta: { title: 'Locations | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/Locations.vue")
        },
        {
          path: "/benchmark/analytics",
          name: "benchmark analytics",
          meta: { title: 'Benchmarking - Analytics | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/BenchmarkAnalytics.vue")
        },
        {
          path: "/guest/analytics",
          name: "guest analytics",
          meta: { title: 'Guest - Analytics | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/SegmentsDashboard.vue")
        },
        {
          path: "/segments",
          name: "segments list",
          meta: { title: 'Guest - Segments | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/SegmentsList.vue")
        },
        {
          path: "/subscribers",
          name: "subscribers",
          meta: { title: 'Guest - Interactions | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/Subscribers.vue")
        },
        {
          path: "/subscriber-list",
          name: "subscriber list",
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/SubscriberList.vue")
        },
        {
          path: "/demographics",
          name: "demographics",
          meta: { title: 'Consumer Insights - Demographics | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/Demographics.vue")
        },
        {
          path: "/campaigns",
          name: "campaigns",
          meta: { title: 'Marketing - Campaigns | Aben' }, //used thru watcher in template
          component: () => import("@/view/pages/Campaigns.vue")
        },
        {
          path: "/marketing-analytics",
          name: "marketing analytics",
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/MarketingAnalytics.vue")
        },
        {
          path: "/campaign/analytics",
          name: "campaign analytics",
          meta: { title: 'Marketing - Analytics | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/CampaignAnalytics.vue")
        },
        {
          path: "/flows",
          name: "flows",
          meta: { title: 'Marketing - Flows | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/Flows.vue")
        },
        {
          path: "/flows/builder/:id",
          name: "flow builder",
          component: () => import("@/view/pages/FlowBuilder.vue")
        },
        {
          path: "/templates",
          name: "templates",
          meta: { title: 'Marketing - Templates | Aben' }, //used thru watcher in template
          component: () => import("@/view/pages/Templates.vue")
        },
        {
          path: "/locations-setup",
          name: "locations setup",
          component: () => import("@/view/pages/LocationsSetup.vue")
        },
        {
          path: "/account",
          name: "account",
          meta: { title: 'My Account | Aben' }, //used thru watcher in template
          component: () => import("@/view/pages/Account.vue")
        },
        {
          path: "/compset",
          name: "compset-overview",
          component: () => import("@/view/pages/CompsetOverview.vue")
        },
        {
          path: "/heatmap",
          name: "heatmap",
          meta: { title: 'Consumer Insights - Customer Journey | Aben' }, //used thru watcher in template
          component: () => import("@/view/pages/Heatmap.vue")
        },
        {
          path: "/aben-overview",
          name: "aben overview",
          component: () => import("@/view/pages/SpendingPulseV2.vue")
        },
        // {
        //   path: "/aben-overview",
        //   name: "aben-overview",
        //   component: () => import("@/view/pages/SpendingPulse.vue")
        // },
        {
          path: "/compset/:selectedLocationId",
          name: "compset-map-view",
          component: () => import("@/view/pages/CompsetMapView.vue")
        },
        {
          path: "/analytics",
          name: "analytics",
          component: () => import("@/view/pages/Analytics.vue")
        },
        {
          path: "/editor-template",
          name: "create template",
          component: () => import("@/view/pages/AddTemplate.vue")
        },
        {
          path: "/editor-template/:id",
          name: "update template",
          component: () => import("@/view/pages/AddTemplate.vue")
        },
        {
          path: "/access-denied",
          name: "not allowed",
          component: () => import("@/view/pages/NotAuthorize.vue")
        },
        {
          path: "/no-access",
          name: "no access",
          component: () => import("@/view/pages/NoAccess.vue")
        },
        {
          path: "/subscriber/profile/:pos_id/:hashid/:id",
          name: "subscriber profile",
          component: () => import("@/view/pages/Subscriber.vue")
        },
        {
          path: "/invoice-list",
          name: "invoice list",
          component: () => import("@/view/pages/InvoiceList.vue")
        },
        {
          path: "/invoice",
          name: "invoice",
          component: () => import("@/view/pages/Invoice.vue")
        },
        {
          path: "/guest/profile/:pos_id/:hashid/:id",
          name: "guest profile",
          component: () => import("@/view/pages/Subscriber.vue")
        },
        {
          path: "/consumer/insights/analytics",
          name: "consumer insights analytics",
          meta: { title: 'Consumer Insights - Analytics | Aben' }, //used thru watcher in template
          component: () => import("@/view/pages/ConsumerInsightsAnalytics.vue")
        },        
      ]
    },
    {
      path: "/login",
      redirect: "/login",
      // component: () => import("@/view/layout/Layout"),
      component: () => import("@/view/pages/Login.vue"),
      children: [
        {
          path: "/login",
          name: "login",
          meta: { title: 'Recommendations | Aben' }, //used thru watcher in template
          // beforeEnter: checkSelectedLocation,
          component: () => import("@/view/pages/Login.vue")
        },        
      ]
    },
    {
      path: "/authenticate",
      redirect: "/authenticate",
      component: () => import("@/view/pages/Authenticate.vue"),
      children: [
        {
          path: "/authenticate",
          name: "authenticate_user",
          component: () => import("@/view/pages/Authenticate.vue")
        },        
      ]
    },
    {
      path: "/hijack",
      redirect: "/hijack",
      component: () => import("@/view/pages/Hijack.vue"),
      children: [
        {
          path: "/hijack",
          name: "hijack_user",
          component: () => import("@/view/pages/Hijack.vue")
        },        
      ]
    },
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    },
    { 
      path: '/:catchAll(.*)', 
      name: 'NotFound',
      component: () => import("@/view/pages/error/Error-1.vue")
      
    }
  ]
});


